import type { PipeTransform } from '@angular/core'
import { Pipe, inject } from '@angular/core'

import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'articleForName',
  standalone: true,
})
export class ArticleForNamePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService)

  transform(value: string): string {
    if (!value) {
      return ''
    }

    const currentLang = this.translateService.getCurrentLang()
    if (value.startsWith('Tijdschrift') && currentLang === 'nl') {
      return `het ${value}`
    }

    return value
  }
}
